
import { Button } from 'antd'
import { PrinterOutlined } from '@ant-design/icons'
import { pdf } from '@react-pdf/renderer'
import * as FileSaver from 'file-saver'
import { cssrs_catalog } from "../../../../escalas/cssrs/cssrs.catalog";
import CssrsPDF from '../../printed-docs/printed-scales/cssrs-pdf'

export default function CssrsResults({ cssrs, pacienteData, fecha }) {

    const handlePrint = async () => {
        const blob = await pdf(<CssrsPDF pacienteData={pacienteData} fecha={fecha} cssrs={cssrs} />).toBlob()
        FileSaver.saveAs(blob, `cssrs_${pacienteData?.name || 'paciente'}.pdf`)
    }

    return (
        <div>
            {/* {JSON.stringify(cssrs)} */}
            {
                cssrs_catalog.map((item, index) => (
                    <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                        <td>{item}</td>
                        <td>{cssrs[index] ? "Si" : "No"}</td>
                    </tr>
                ))
            }
            <div style={{ marginTop: 10, textAlign: 'right' }}>
                <Button icon={<PrinterOutlined />} onClick={handlePrint}>Imprimir escala en pdf</Button>
            </div>
        </div>
    )
}